import { PickerSuggestionsRequestSchema, PickerSuggestionsResponseSchema } from './picker-suggestions.schema';
export const pickerSuggestionsContract = {
    method: 'GET',
    path: '/api/v2/picker-suggestions',
    description: 'Returns ranked id buckets (recently used, role, process, department) for the entity picker',
    requestSchema: PickerSuggestionsRequestSchema,
    responseSchema: PickerSuggestionsResponseSchema,
    statusCodes: {
        success: 200,
        errors: {
            400: 'Bad Request - invalid query parameters',
            401: 'Unauthorized - user not authenticated'
        }
    }
};

//# sourceMappingURL=picker-suggestions.contract.js.map